import React from 'react';
import { __, setTableParams, validateForm } from '../core/utils';
import styles from '../styles/wizards/CreateFolderWizard.scss';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { attachModelsToFolders } from '../redux/actions/table/folders';
import { listCurrentSetPlans } from '../redux/actions/table/current_set_plans';
import AttachPlansToFoldersForm from '../forms/attach_plans_to_folders_wizard/AttachPlansToFoldersForm';
import FolderAddIcon from '../assets/images/folder-add-64x64.svg';

const AttachPlansToFoldersWizard = ({
  match,
  onClose,
  plan_ids = [],
  folders = [],
  onAttached,
}) => {
  const _handleSubmit = (formData) => {
    const folder_ids = formData.folder_ids || [];
    const removed_folder_ids = formData.removed_folder_ids || [];

    // if (!folder_ids.length && !removed_folder_ids.length) {
    //   return Promise.resolve();
    // }

    return validateForm(
      attachModelsToFolders(match.params.stage, {
        module: 'plans',
        model_ids: plan_ids,
        folder_ids,
        removed_folder_ids,
      }).then(() => {
        listCurrentSetPlans(match.params.stage);
        setTableParams('current_set_plans', {
          folders_reload_at: Date.now(),
        });
        setNotification(__('Plans have been added to selected folders.'));
        if (onAttached) {
          onAttached();
        }
        onClose();
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('Add to folders')}</span>
          <span>{__('Select one or more folders')}</span>
        </div>
        <div className={styles.right}>
          <FolderAddIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AttachPlansToFoldersForm
          onSubmit={_handleSubmit}
          onClose={onClose}
          folders={folders}
          plan_ids={plan_ids}
        />
      </div>
    </>
  );
};

export default withRouter(AttachPlansToFoldersWizard);
